<p class="text">
  {{ 'claims.list.exportDialog.unauthorized' | translate }} 
</p>
